export default __webpack_public_path__ + "static/media/agencia-digital-header.63e5221e.svg";